import apiClient from "../../../Service/api"

// THESE ARE ALL THE FUNCTIONS IN ORDER TO GET EVENTS, MANUSCRIPT, PRINT, IMAGE DATA AND POST.

//: POST TO ADD EVENTS 


export const addEvent = (event) => 
{
    return  apiClient.post('/events', event).then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

//: POST TO ADD IMAGES
export const addImage = (image) => 
{ 
    return  apiClient.post('/images', image).then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

//: POST TO ADD MANUSCRIPTS
export const addManuscript = (manuscript) => 
{
    return apiClient.post('/manuscripts', manuscript).then(res => {
        return res.data
    })
     .catch(error => {
         console.log('ERROR', error)
     })

}

//: POST TO ADD PRINTS
export const addPrint = (print) => 
{
    return apiClient.post('/prints', print).then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error )
    })
}

//: GET ALL THE EVENTS
export const getAllEvents = () => 
{
    return apiClient.get('/events').then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

//: GET ALL THE IMAGES
export const getAllImages = () => 
{
    return apiClient.get('/images').then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

//: GET ALL THE PRINTS
export const getAllPrints = () => 
{
    return apiClient.get('/prints').then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

//: GET ALL THE MANUSCRIPTS
export const getAllManuscripts = () => 
{
    return apiClient.get('/manuscripts').then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

//DELETE SINGLE EVENT FROM DATABASE
export const deleteSingleEvent = recordId => {
   return apiClient.delete(`/events/${recordId}`).then(res => {
        return true
      })
      .catch(error => {
          console.log('ERROR', error)
      }) 
  }
//DELETE SINGLE IMAGE FROM DATABASE
  export const deleteSingleImage = idImage => {
    return apiClient.delete(`/images/${idImage}`).then(res => {
         return true
       })
       .catch(error => {
           console.log('ERROR', error)
       }) 
   }

//DELETE SINGLE MANUSCRIPT FROM DATABASE
   export const deleteSingleManuscript = idManuscript  => {
       return apiClient.delete(`/manuscripts/${idManuscript}`).then(res => {
           return true
       })
       .catch(error => {
           console.log('ERROR', error)
       })
   }

//DELETE SINGLE PRINT FROM DATABASE
   export const deleteSinglePrint = idPrint => {
       return apiClient.delete(`/prints/${idPrint}`).then(res => {
           return true
       })
       .catch(error => {
           console.log('ERROR', error)
       })
   }

// UPDATE SINGLE IMAGE ON THE DATABASE

export const updateSingleImage = (idImage, dati) => {
    return apiClient.put(`/images/${idImage}`, dati).then(res => {
      return res.data 
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

// UPDATE SINGLE MANUSCRIPT ON THE DATABASE

export const updateSingleManuscript = (idManuscript, dati) => {
    return apiClient.put(`/manuscripts/${idManuscript}`, dati).then(res => {
      return res.data 
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}

// UPDATE SINGLE PRINT ON THE DATABASE

export const updateSinglePrint = (idPrint, dati) => {
    return apiClient.put(`/prints/${idPrint}`, dati).then(res => {
      return res.data 
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}


//: LOG - UPDATE IMAGE.
export const trackUpdateImage = (userId, imageId) => 
{
    return apiClient.post(`/images/${userId}/update/${imageId}`).then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error )
    })
}

//: GET ALL THE LAST UPDATES: http://localhost:8080/api/events/lastUpdates

export const getAllTheLastUpdates = () =>
{
    return apiClient.get('/events/lastUpdates').then(res => {
        return res.data
    })
    .catch(error => {
        console.log('ERROR', error)
    })
}